import axios from 'axios';
import { PUBLISHING_SERVICE_URL } from '~/config';
import { handleNetworkError, withVersionHeaders } from '../utilities/axiosUtilities';
export function getPaymentRequired(id) {
  const url = `${PUBLISHING_SERVICE_URL}/security-review-payment/payment/${id}`;
  return axios.get(url, withVersionHeaders()).then(response => {
    var _response$data;
    return (_response$data = response === null || response === void 0 ? void 0 : response.data) !== null && _response$data !== void 0 ? _response$data : null;
  }).catch(handleNetworkError);
}
export function makePayment(id, email) {
  const url = `${PUBLISHING_SERVICE_URL}/security-review-payment/payment/${id}`;
  return axios.post(url, {
    email
  }, withVersionHeaders()).then(response => {
    var _response$data2;
    return (_response$data2 = response === null || response === void 0 ? void 0 : response.data) !== null && _response$data2 !== void 0 ? _response$data2 : null;
  }).catch(handleNetworkError);
}